<template>
  <ol-tile-layer
    v-if="$store.state.karatay_ada_parsel.type === 'KaratayWS:kbs_para'"
  >
    <ol-source-tile-wms
      :url="$store.state.karatay_ada_parsel.url"
      :layers="$store.state.karatay_ada_parsel.type"
    ></ol-source-tile-wms>
  </ol-tile-layer>
</template>